import { Box, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';

export default function BusinessKnowledgeSkeleton() {
  return (
    <>
      {/* Header Section */}
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems={{ xs: 'flex-start', lg: 'center' }}
        flexDirection={{ xs: 'column', lg: 'row' }}
        gap={{ xs: 1.5, lg: 0 }}
        mb={2}
        mt={4}
      >
        <Skeleton variant='text' width={200} height={40} />
        <Skeleton variant='rectangular' height={40} sx={{ borderRadius: 1, width: { xs: '100%', sm: 80 } }} />
      </Box>

      {/* Knowledge Base Cards Grid */}
      <Grid container spacing={2} mt={3}>
        {[...Array(6)].map((_, index) => (
          <Grid
            key={index}
            size={{ xs: 12, sm: 6, lg: 4 }}
            bgcolor='background.paper'
            border='1px solid #F3F3F3'
            borderRadius={0.5}
            padding={2}
          >
            {/* Card Header */}
            <Box display='flex' justifyContent='space-between' alignItems='center'>
              <Box display='flex' alignItems='center' gap={1}>
                <Skeleton variant='rectangular' width={20} height={20} sx={{ borderRadius: 0.5 }} />
                <Skeleton variant='text' width={120} height={24} />
              </Box>
              <Skeleton variant='rectangular' width={24} height={24} sx={{ borderRadius: '50%' }} />
            </Box>

            {/* Description */}
            <Skeleton variant='text' width='100%' height={20} sx={{ mt: 1, mb: 3 }} />
            <Skeleton variant='text' width='80%' height={16} sx={{ mb: 3 }} />

            {/* Docs Count */}
            <Box display='flex' gap={1} alignItems='center' mb={1}>
              <Skeleton variant='rectangular' width={16} height={16} />
              <Skeleton variant='text' width={60} height={16} />
            </Box>

            {/* Created Date */}
            <Box display='flex' gap={1} alignItems='center'>
              <Skeleton variant='rectangular' width={16} height={16} />
              <Skeleton variant='text' width={100} height={16} />
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
